/**
 * Date Preset Helpers for Rate Review Module
 * @module RateReviewDatePresetHelpers
 */

import dayjs from "dayjs";
import { RATE_REVIEW_CONSTANTS } from "../constants/rateReviewConstants";

/**
 * Gets date range (start and end dates) for a given preset
 * @param {string} preset - Preset key (today, yesterday, week_to_date, etc.)
 * @returns {{start: string|null, end: string|null}} Date range in YYYY-MM-DD format
 */
export const getDateRangeFromPreset = (preset) => {
  if (!preset) {
    return { start: null, end: null };
  }

  const today = dayjs();
  let startDate = null;
  let endDate = null;

  switch (preset) {
    case 'today':
      startDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'yesterday':
      startDate = today.subtract(1, 'day').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.subtract(1, 'day').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'week_to_date':
      startDate = today.startOf('week').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'month_to_date':
      startDate = today.startOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'year_to_date':
      startDate = today.startOf('year').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'last_week':
      startDate = today.subtract(1, 'week').startOf('week').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.subtract(1, 'week').endOf('week').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'last_month':
      startDate = today.subtract(1, 'month').startOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.subtract(1, 'month').endOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'last_year':
      startDate = today.subtract(1, 'year').startOf('year').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.subtract(1, 'year').endOf('year').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'last7days':
      startDate = today.subtract(7, 'day').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'last30days':
      startDate = today.subtract(30, 'day').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'thisMonth':
      startDate = today.startOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.endOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'lastMonth':
      startDate = today.subtract(1, 'month').startOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.subtract(1, 'month').endOf('month').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    case 'thisYear':
      startDate = today.startOf('year').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      endDate = today.endOf('year').format(RATE_REVIEW_CONSTANTS.DATE_FORMAT);
      break;
    default:
      return { start: null, end: null };
  }

  return { start: startDate, end: endDate };
};

